import { Component, OnInit, Input } from '@angular/core';
import value from '*.json';

@Component({
  selector: 'baf-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css']
})
export class ProgressBarComponent implements OnInit {
  @Input()
  min = 0;

  @Input()
  max = 100;

  @Input()
  value = 0;

  @Input()
  height = 20;

  @Input()
  operation = '';

  @Input()
  message = 'Wykonanie';

  constructor() {}

  format(value) {
    return `Wykonanie: ${Math.floor(100 * value)}%`;
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/progress-bar/progress-bar.component.ts